import { render, staticRenderFns } from "./HospitalEdit.vue?vue&type=template&id=34998113"
import script from "./HospitalEdit.vue?vue&type=script&lang=js"
export * from "./HospitalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports